export default __webpack_public_path__ + "static/media/onthemove.35b1c323.gif";